import React, { MouseEventHandler, ReactElement, Suspense, useState } from 'react';

import LoadingOverlay from 'atomic/loading-overlay';
import Button from 'atomic/button/button';

import './review-item-message-avatar.scss';

const CompanyViewOpiconnectModal = React.lazy(() => import('components/company-view/company-view-opiconnect/modal/company-view-opiconnect-modal'));

const ReviewItemMessageAvatar: React.FC<{ type: string; }> = ({ type }): ReactElement => {
    const [showModal, setShowModal] = useState(false);

    const handleClick: MouseEventHandler = e => {
        e.preventDefault();
        setShowModal(true);
    };

    switch (type) {
        case 'company':
            return <i className="review-item__message-avatar-cart opicon-cart"/>;
        case 'delivery':
            return <i className="review-item__message-avatar-truck opicon-truck"/>;
        case 'opiconnect':
            return (
                <>
                    <Button className="review-item__message-avatar-opiconnect-btn" wrapper={true} onClick={handleClick}>
                        <i className="review-item__message-avatar-opiconnect opicon-opiconnect-blue">
                            <span className="path1"/>
                            <span className="path2"/>
                        </i>
                    </Button>
                    {showModal && (
                        <Suspense fallback={<LoadingOverlay/>}>
                            <CompanyViewOpiconnectModal onClose={(): void => setShowModal(false)}/>
                        </Suspense>
                    )}
                </>
            );
        case 'admin':
            return <i className="review-item__message-avatar-repair opicon-repair"/>;
        default:
            return <i className="review-item__message-avatar-comment opicon-comments"/>;
    }
};

export default ReviewItemMessageAvatar;
